import { render } from "./CheckGroup.vue?vue&type=template&id=28478d1f"
import script from "./CheckGroup.vue?vue&type=script&lang=js"
export * from "./CheckGroup.vue?vue&type=script&lang=js"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__